import { FaresColSize } from './interface'

export const getColSpan = (colSizeDictionary: FaresColSize, index: number): number | undefined => {
    const prefix = 'col'
    const itemCol = index + 1
    return colSizeDictionary[prefix + itemCol]
}
